import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalFormContainerComponent } from '../../../../../../components/ui/modal-form-container/modal-form-container.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IOrganization } from '../../../../../../types/contactModule';

@Component({
  selector: 'message-selected-organizations',
  standalone: true,
  imports: [ModalFormContainerComponent, MatTooltipModule],
  templateUrl: './message-selected-organizations.component.html',
  styleUrls: ['./message-selected-organizations.component.css', '../selected-list.css'],
})
export class MessageSelectedOrganizationsComponent {
  constructor() {}

  @Input() open: boolean = false;
  @Output() close = new EventEmitter();
  @Input() selectedOrganizations: IOrganization[] = [];
  @Output() removeOrganization = new EventEmitter<IOrganization>();

  handleRemoveOrganization(item: IOrganization) {
    this.removeOrganization.emit(item);
  }

  closeModal() {
    this.close.emit();
  }
}
